document.addEventListener('DOMContentLoaded', () => {
  const dataEl = document.getElementById('variant-stock-data');
  const map = dataEl ? JSON.parse(dataEl.textContent) : null;
  const out = document.getElementById('VariantStock');
  if (!map || !out) return;

  function renderFor(variantId) {
    const rec = map[variantId];
    if (!rec) return;
    if (!rec.available) { out.innerHTML = '<span class="soldout">Sold out</span>'; return; }
    const q = Number(rec.qty || 0);
    if (q > 0 && q <= 5) { out.textContent = `Only ${q} left`; out.classList.add('variant-stock--low'); }
    else { out.textContent = 'In stock'; out.classList.remove('variant-stock--low'); }
  }

  // 1) listen to Dawn/OS2 custom event if available
  document.addEventListener('variant:change', (e) => {
    const v = e.detail && e.detail.variant;
    if (v && v.id) renderFor(String(v.id));
  });

  // 2) Fallback: watch hidden variant id input in product form
  const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
  if (idInput) {
    const obs = new MutationObserver(() => renderFor(idInput.value));
    obs.observe(idInput, { attributes: true, attributeFilter: ['value'] });
    renderFor(idInput.value);
  }
});
